import { FooterContainer } from './style'

export default function Footer() {
  return (
    <FooterContainer>
      Made with 🤎 by{' '}
      <a href="https://github.com/gabrlcj" target="_blank" rel="noreferrer">
        Gabriel Bittencourt
      </a>{' '}
      © 2021
    </FooterContainer>
  )
}
